//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useEffect } from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const lastPeriod = useStore((state) => state.lastPeriod);
  const setLastPeriod = useStore((state) => state.setLastPeriod);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.lastPeriod.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={lastPeriod}
          onChange={(value) => {
            setLastPeriod(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'last-period',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Still having regular periods'}>
            {t('onboarding.lastPeriod.options.regualar')}
          </Option>
          <Option value={'Irregular or occasional periods'}>
            {t('onboarding.lastPeriod.options.irregular')}
          </Option>
          <Option value={'It’s been over 12 months'}>
            {t('onboarding.lastPeriod.options.overTwelveMonth')}
          </Option>
          <Option value={'Not sure'}>{t('onboarding.lastPeriod.options.notSure')}</Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
